import { http } from '@/utils/http/axios';
import { LoginRequest, UserInfo } from './type';
export function loginApi(data: LoginRequest) {
  return http.request(
    {
      data,
      url: '/login',
      method: 'post',
    },
    {
      isTransformResponse: false,
    }
  );
}

export function logoutApi() {
  return http.request({
    url: '/logout',
    method: 'get',
  });
}
export function getMemberInfoApi() {
  return http.request<UserInfo>({
    url: '/member',
    method: 'get',
  });
}

export function checkCookieApi() {
  return http.request<UserInfo>({
    url: '/member',
    method: 'get',
  });
}
